import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeToDateCommand extends BaseCommand {
  CommandName = "ChangeToDate";
  Command: { TmpId: string; Value: string };
  constructor(sessionId: string, operationId: string, tmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value };
  }
}
